export default __webpack_public_path__ + "static/media/exchange.443dd066.svg";